import React from 'react'
import { Stack } from '@mantine/core'

import { AttendeeCard } from '@/components/Event/NewScript/components/common/AttendeeCard/AttendeeCard'
import { IdentityDocumentInput } from '@/components/Event/NewScript/components/common/IdentityDocumentCard/IdentityDocumentInput'
import {
  ActionContainer,
  ActionText,
} from '@/components/Event/NewScript/components/common/ScriptTimeline'
import { getEventTypeShortLabel } from '@/components/Event/NewScript/utils/event'
import {
  IDENTITY_DOCUMENT_STIPULATION_STATUSES,
  IdentityDocumentStatus,
} from '@/constants'
import { Event, ScriptAttendee } from '@/types'

type Props = {
  guardian: ScriptAttendee
  namePrefix: string
  attendeeChanged: (attendee: ScriptAttendee) => void
  event: Event
  witnessName: string
  allAttendees: ScriptAttendee[]
}

export const GuardianInput: React.FC<Props> = ({
  guardian,
  namePrefix,
  attendeeChanged,
  event,
  witnessName,
  allAttendees,
}) => {
  const { identity_document: identityDocument } = guardian
  const shouldShowStipulation = IDENTITY_DOCUMENT_STIPULATION_STATUSES.includes(
    identityDocument?.status as IdentityDocumentStatus,
  )

  return (
    <>
      <ActionContainer outer>
        <Stack>
          <ActionText mono>
            Would the guardian for the witness identify yourself, confirm the
            nature of your relationship with the witness, and spell your last
            name for the record?
          </ActionText>
          <AttendeeCard
            attendee={guardian}
            onSubmitClick={attendeeChanged}
            event={event}
            namePrefix={namePrefix}
            allAttendees={allAttendees}
          />
        </Stack>
      </ActionContainer>
      <ActionContainer outer>
        <Stack>
          <ActionText mono>
            Mr./Ms. {guardian.name}, can you please hold a valid government
            photo identification up to the screen to verify your identity?
          </ActionText>
          <ActionContainer>
            <IdentityDocumentInput
              namePrefix={`${namePrefix}.identity_document`}
              attendee={guardian}
              hideButton
              onSubmitClick={attendeeChanged}
            />
          </ActionContainer>
        </Stack>
      </ActionContainer>
      {shouldShowStipulation && (
        <ActionContainer outer>
          <ActionText mono>
            For the record, the guardian has not presented a valid ID for
            verification. Do all parties stipulate to the guardian's identity
            and to my administering the oath to this witness?
          </ActionText>
        </ActionContainer>
      )}
      <ActionContainer outer>
        <ActionText mono>
          {guardian.name}, do you consent to this{' '}
          {getEventTypeShortLabel(event)} being conducted for {witnessName}?
        </ActionText>
      </ActionContainer>
    </>
  )
}
